export class DataQualityHeadlineKpi {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "status",
            "baseName": "status",
            "type": "HealthStatus",
            "format": ""
        },
        {
            "name": "label",
            "baseName": "label",
            "type": "string",
            "format": ""
        },
        {
            "name": "value",
            "baseName": "value",
            "type": "string",
            "format": ""
        },
        {
            "name": "subText",
            "baseName": "subText",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataQualityHeadlineKpi.attributeTypeMap;
    }
    constructor() {
    }
}
